import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "../motion/Reveal";
import { useSite } from "../../lib/site";
import { scrollToId } from "../../lib/scroll";

export const HowItWorks = () => {
  const { content } = useSite();
  const s = content.pasos;
  const listRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: listRef, offset: ["start 75%", "end 55%"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 90, damping: 22 });

  return (
    <section id="como-funciona" className="grain relative overflow-hidden bg-ink py-14 text-white sm:py-20 lg:py-24" data-testid="como-funciona-section">
      <div className="container-x relative grid gap-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Eyebrow>{s.eyebrow}</Eyebrow>
            <MaskLines lines={s.title_lines} className="mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-[-0.035em] sm:text-5xl lg:text-[3.2rem]" testId="como-funciona-title" />
            <Reveal className="mt-5 max-w-md text-base leading-relaxed text-[#C9D0E4] sm:text-lg">
              <p>{s.text}</p>
              <button onClick={() => scrollToId("registro")} className="btn-leaf group mt-6" data-testid="como-funciona-cta">
                Te registras hoy <ArrowUpRight className="btn-arrow h-5 w-5" />
              </button>
            </Reveal>
          </div>
        </div>
        <div ref={listRef} className="relative lg:col-span-7">
          <div className="absolute bottom-0 left-[21px] top-0 w-px bg-white/10 sm:left-[27px]">
            <motion.div style={{ scaleY }} className="h-full w-full origin-top bg-leaf" />
          </div>
          <ol className="space-y-3">
            {s.steps.map((step, i) => (
              <Reveal as="li" key={i} delay={0.05} className="relative flex gap-4 sm:gap-5" data-testid={`step-${i + 1}`}>
                <span className="relative z-10 grid h-11 w-11 shrink-0 place-items-center rounded-full border border-leaf/60 bg-ink font-display text-lg font-semibold text-leaf sm:h-14 sm:w-14 sm:text-xl">
                  {i + 1}
                </span>
                <div className="flex-1 rounded-[1.25rem] border border-white/10 bg-white/[0.04] p-4 transition-colors duration-500 hover:border-leaf/40 hover:bg-white/[0.07] sm:p-5">
                  <h3 className="font-display text-lg font-semibold uppercase tracking-tight sm:text-xl">{step.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-[#C9D0E4] sm:text-base">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
